import { cn } from '../../../utils/cn';
import type { TransferStatus } from '../../../types/nursery';

const STYLES: Record<TransferStatus, [string, string]> = {
  planned:    ['bg-neutral-100 text-neutral-700', 'Planned'],
  in_transit: ['bg-blue-100 text-blue-700', 'On the road'],
  received:   ['bg-green-100 text-green-700', 'Received'],
  cancelled:  ['bg-red-100 text-red-700', 'Cancelled'],
};

export function TransferStatusBadge({ status }: { status: TransferStatus }) {
  const [cls, label] = STYLES[status];
  return <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold whitespace-nowrap', cls)}>{label}</span>;
}

export default TransferStatusBadge;
